module.exports = __webpack_public_path__ + "img/9788976825872.4e7d94cb.jpg";